// ── Android search tap fix ────────────────────────────────────────────────────
// The BSS Banner slider calls preventDefault() on touchstart for swipe
// detection. On Android Chrome this suppresses the synthesized click event that
// the theme's jQuery delegated handler relies on (iOS handles this differently).
// We bypass the broken touch→click pipeline by catching touchend directly on
// the search trigger and calling showSearch() ourselves.
(function () {
  function fixSearchTouch() {
    document.addEventListener('touchend', function (e) {
      var trigger = e.target.closest('[data-show-search-trigger]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      if (window.PXUTheme && window.PXUTheme.jsHeader) {
        window.PXUTheme.jsHeader.showSearch();
      } else {
        trigger.click();
      }
    }, { passive: false });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixSearchTouch);
  } else {
    fixSearchTouch();
  }
})();

// ── LOK swatch detection (REMOVED) ───────────────────────────────────────────
// LinkedOption King is hidden storewide and replaced by the native swatch system.
// Button state ("Add to Cart" vs "Select Options") is now decided solely by the
// Liquid template via product.has_only_default_variant. The old convertCardIfLOK /
// watchCardsForLOK logic re-derived button state from LOK element presence, which
// wrongly flipped single-variant products (e.g. Sourdough Towel) to "Select Options".

// ── Collection card AJAX Add to Cart ─────────────────────────────────────────
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.gs-atc-btn[data-variant-id]');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  var variantId = btn.getAttribute('data-variant-id');
  var originalText = btn.textContent.trim();

  btn.disabled = true;
  btn.textContent = 'Adding…';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
  })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (data.status) {
        btn.disabled = false;
        btn.textContent = originalText;
        alert(data.description || 'Could not add to cart.');
        return;
      }

      btn.textContent = 'Added!';

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var counters = document.querySelectorAll('.cart-item-count, .js-cart-count, [data-cart-count]');
          counters.forEach(function (el) { el.textContent = cart.item_count; });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        });

      setTimeout(function () {
        btn.disabled = false;
        btn.textContent = originalText;
      }, 2000);
    })
    .catch(function (err) {
      btn.disabled = false;
      btn.textContent = originalText;
      console.error('ATC error:', err);
    });
});

// ── Sibling swatches card swap handler ───────────────────────────────────────
var _swatchTextureState = {};

function doSiblingSwap(card, target) {
  // ── Swap primary image ────────────────────────────────────────────────────
  var primaryImg = card.querySelector('.product__imageContainer .image-element__wrap img:not(.secondary)');
  if (primaryImg && target.primary_image) {
    var pi = target.primary_image;
    primaryImg.setAttribute('data-src', pi.data_src);
    primaryImg.setAttribute('data-srcset', pi.data_srcset);
    primaryImg.setAttribute('data-aspectratio', pi.data_aspectratio);
    primaryImg.setAttribute('alt', pi.alt);
    primaryImg.setAttribute('width', pi.width);
    primaryImg.setAttribute('height', pi.height);
    var primaryWrapper = primaryImg.closest('.image-element__wrap');
    var existingPrimaryStyle = (primaryWrapper && primaryWrapper.getAttribute('style')) || '';
    var primaryMaxHeightMatch = existingPrimaryStyle.match(/max-height:\s*([^;]+)/);
    var primaryMaxHeight = primaryMaxHeightMatch ? primaryMaxHeightMatch[1].trim() : '400px';
    var primaryStyle = 'max-height: ' + primaryMaxHeight + '; max-width: calc(' + pi.width + ' / ' + pi.height + ' * ' + primaryMaxHeight + ');';
    if (primaryWrapper) primaryWrapper.setAttribute('style', primaryStyle);
    primaryImg.setAttribute('style', primaryStyle);
    primaryImg.classList.remove('lazyloaded');
    primaryImg.classList.add('lazyload');
    if (window.lazySizes) {
      window.lazySizes.loader.unveil(primaryImg);
    }
  }

  // ── Swap secondary image ──────────────────────────────────────────────────
  var secImg = card.querySelector('.product__imageContainer .image-element__wrap img.secondary');
  // Guard: skip update when target has no real secondary (has_secondary_image === false means the
  // JSON secondary_image is a fallback copy of the primary — updating it would cause a no-op hover
  // fade and needlessly trigger lazySizes. Non-grouped targets have undefined → !== false → update
  // as before, so this guard is invisible to non-grouped products.
  if (secImg && target.secondary_image && target.has_secondary_image !== false) {
    var si = target.secondary_image;
    secImg.setAttribute('data-src', si.data_src);
    secImg.setAttribute('data-srcset', si.data_srcset);
    secImg.setAttribute('data-aspectratio', si.data_aspectratio);
    secImg.setAttribute('alt', si.alt);
    secImg.setAttribute('width', si.width);
    secImg.setAttribute('height', si.height);
    var secWrapper = secImg.closest('.image-element__wrap');
    var existingSecStyle = (secWrapper && secWrapper.getAttribute('style')) || '';
    var secMaxHeightMatch = existingSecStyle.match(/max-height:\s*([^;]+)/);
    var secMaxHeight = secMaxHeightMatch ? secMaxHeightMatch[1].trim() : '400px';
    var secStyle = 'max-height: ' + secMaxHeight + '; max-width: calc(' + si.width + ' / ' + si.height + ' * ' + secMaxHeight + ');';
    if (secWrapper) secWrapper.setAttribute('style', secStyle);
    secImg.setAttribute('style', secStyle);
    secImg.classList.remove('lazyloaded');
    secImg.classList.add('lazyload');
    if (window.lazySizes) {
      window.lazySizes.loader.unveil(secImg);
    }
  }

  // ── Per-member hover-swap state ───────────────────────────────────────────
  // has_secondary_image (bool) is emitted by sibling-swatches-card.liquid for every
  // member entry. true = real image secondary exists; false = no secondary (or video,
  // which is suppressed storewide). undefined = non-grouped product or pre-flag JSON
  // — leave those untouched; the static img.secondary from Liquid handles them.
  //
  // Variant A (canonical had no secondary → img.secondary not in server DOM): we
  // create the element from JSON data (option i — JSON-based construction) rather than
  // a <template> clone. Rationale: all needed attributes are already in
  // target.secondary_image; image-element.liquid has 6+ render paths making a
  // faithful template impractical; doSiblingSwap already has DOM-creation precedent
  // (the LE badge). The transition class is cloned from the existing primary img.
  if (target.has_secondary_image === false) {
    card.classList.add('gs-secondary-none');
  } else if (target.has_secondary_image === true) {
    card.classList.remove('gs-secondary-none');

    if (!secImg && target.secondary_image) {
      // Variant A: img.secondary absent from DOM — build it and insert it.
      var si2 = target.secondary_image;

      // Clone the lazySizes transition class (transition--blur-up, transition--color,
      // etc.) from the primary img so loading behaviour matches server-rendered cards.
      var primaryImgEl = card.querySelector('.product__imageContainer .image-element__wrap img:not(.secondary)');
      var transitionClass = '';
      if (primaryImgEl) {
        var priClasses = Array.from(primaryImgEl.classList);
        var tc = priClasses.find(function(c) { return c.startsWith('transition--'); });
        if (tc) transitionClass = ' ' + tc;
      }

      var newSecWrap = document.createElement('div');
      newSecWrap.className = 'image-element__wrap';

      var newSecImg = document.createElement('img');
      // Classes match what image-element renders with additional_classes:'secondary swap--visible'.
      // Our CSS (.collection-matrix ... img.secondary) already targets this element —
      // the swap--visible class is subject to the same visibility:visible !important override
      // we apply to server-rendered secondary imgs.
      newSecImg.className = 'lazyload' + transitionClass + ' secondary swap--visible';
      newSecImg.setAttribute('alt', si2.alt || '');
      newSecImg.setAttribute('data-src', si2.data_src);
      newSecImg.setAttribute('data-srcset', si2.data_srcset);
      newSecImg.setAttribute('data-aspectratio', si2.data_aspectratio);
      newSecImg.setAttribute('data-sizes', 'auto');
      newSecImg.setAttribute('width', si2.width);
      newSecImg.setAttribute('height', si2.height);
      // SVG placeholder prevents a broken-image icon before lazySizes loads data-src.
      newSecImg.setAttribute('srcset',
        'data:image/svg+xml;utf8,<svg%20xmlns=\'http://www.w3.org/2000/svg\'' +
        '%20width=\'' + si2.width + '\'%20height=\'' + si2.height + '\'></svg>');

      newSecWrap.appendChild(newSecImg);
      // Append inside the <a> — same location as the Liquid render in product-thumbnail.liquid.
      var imgLinkEl = card.querySelector('.product__imageContainer > a');
      if (imgLinkEl) imgLinkEl.appendChild(newSecWrap);
      if (window.lazySizes) window.lazySizes.loader.unveil(newSecImg);
    }
  }

  // ── Swap image container link ─────────────────────────────────────────────
  var imgLink = card.querySelector('.product__imageContainer > a');
  if (imgLink) imgLink.href = target.url;

  // ── Update hidden product link — actual click-target over the image area ──
  var hiddenLink = card.querySelector('.hidden-product-link');
  if (hiddenLink && target.url) hiddenLink.setAttribute('href', target.url);

  // ── Swap title and its link ───────────────────────────────────────────────
  var mobilehide = card.querySelector('.mobilehide');
  if (mobilehide) {
    var titleEl = mobilehide.querySelector('.product-thumbnail__title');
    if (titleEl) {
      titleEl.textContent = target.title.split(' | ')[0];
      var titleLink = titleEl.closest('a');
      if (titleLink) titleLink.href = target.url;
    }

    // Full product title — color-collection template cards only (no-op on standard cards)
    var fullTitleEl = card.querySelector('.js-product-title');
    if (fullTitleEl) {
      var titleP = fullTitleEl.querySelector('.product-thumbnail__title');
      if (titleP) titleP.innerText = target.title;
      else fullTitleEl.innerText = target.title;
      fullTitleEl.href = target.url;
    }

    // ── Swap price ──────────────────────────────────────────────────────────
    var priceDiv = mobilehide.querySelector('.price');
    if (priceDiv) {
      var centerEl = priceDiv.closest('center');
      if (centerEl) centerEl.outerHTML = target.price_html;
    }

    // ── Swap ATC button ─────────────────────────────────────────────────────
    var atcBtn = mobilehide.querySelector('.gs-atc-wrapper .gs-atc-btn');
    if (atcBtn) {
      atcBtn.setAttribute('data-product-id', target.product_id);
      atcBtn.setAttribute('data-id', target.product_id);
      atcBtn.setAttribute('data-url', target.url);

      if (target.available === false) {
        atcBtn.removeAttribute('data-variant-id');
        atcBtn.classList.remove('add-to-cart', 'js-quick-shop-link');
        atcBtn.setAttribute('disabled', '');
        atcBtn.textContent = 'Sold Out';
      } else {
        atcBtn.removeAttribute('disabled');
        if (target.has_only_default_variant) {
          atcBtn.setAttribute('data-variant-id', target.default_variant_id);
          atcBtn.classList.add('add-to-cart');
          atcBtn.classList.remove('js-quick-shop-link');
          atcBtn.textContent = 'Add to Cart';
        } else {
          atcBtn.removeAttribute('data-variant-id');
          atcBtn.classList.remove('add-to-cart');
          atcBtn.classList.add('js-quick-shop-link');
          atcBtn.textContent = 'Select Options';
        }
      }
    }
  }

  // ── Dynamic badges (Limited Edition, Clearance, Sale) ─────────────────────
  // Each badge is shown/hidden to match the swatch-selected sibling. Clearance mirrors
  // the "clearance" collection check in product-thumbnail__sticker; Sale mirrors its
  // rule (available + compare-at above price + in a "sale" collection). Both are
  // computed per sibling in sibling-swatches-card.liquid.
  syncCardBadge(card, 'thumbnail-sticker--limited-edition', 'Limited Edition', !!target.limited_edition);
  syncCardBadge(card, 'thumbnail-sticker--clearance', 'Clearance', !!target.clearance, 'thumbnail-sticker--sale');
  syncCardBadge(card, 'thumbnail-sticker--sale', 'Sale', !!target.on_sale);
  // Sold Out mirrors the `unless product.available` sticker; it renders last in Liquid, so append.
  syncCardBadge(card, 'thumbnail-sticker--sold-out', 'Sold Out', target.available === false);
}

// Show or hide one sticker on a card, creating the sticker holder if the card has none.
// beforeClass (optional) keeps a newly created badge ahead of that sticker, matching Liquid order.
function syncCardBadge(card, badgeClass, label, show, beforeClass) {
  var badge = card.querySelector('.' + badgeClass);
  if (!show) {
    if (badge) badge.style.display = 'none';
    return;
  }
  if (badge) {
    badge.style.display = '';
    return;
  }
  var holderContent = card.querySelector('.sticker-holder__content');
  if (!holderContent) {
    var imgLink = card.querySelector('.product__imageContainer > a');
    if (!imgLink) return;
    var existingHolder = document.querySelector('.sticker-holder');
    var newHolder = document.createElement('div');
    newHolder.className = existingHolder ? existingHolder.className : 'sticker-holder sticker-shape-rounded sticker-position-left';
    holderContent = document.createElement('div');
    holderContent.className = 'sticker-holder__content sticker-holder__content--thumbnail';
    newHolder.appendChild(holderContent);
    imgLink.prepend(newHolder);
  }
  badge = document.createElement('div');
  badge.className = 'thumbnail-sticker ' + badgeClass;
  badge.innerHTML = '<span class="thumbnail-sticker__text">' + label + '</span>';
  var nextBadge = beforeClass ? holderContent.querySelector('.' + beforeClass) : null;
  holderContent.insertBefore(badge, nextBadge);
}

function buildTexturePicker(card, colorKey, data, resetToBasic, fallbackTextureIdx) {
  var container = card.querySelector('[data-texture-picker]');
  if (!container) return;

  var colorData = data.siblings_by_option_1_name[colorKey];
  if (!colorData || !colorData.option_2_siblings) {
    container.innerHTML = '';
    return;
  }

  // All entries are published — draft excluded by Liquid's member != blank gate
  var siblings = colorData.option_2_siblings;
  var swatchCard = card.querySelector('.sibling-swatches-card');
  var productId = swatchCard ? swatchCard.dataset.cardId : '';

  if (siblings.length < 1) {
    container.innerHTML = '';
    return;
  }

  var activeIdx = 0;
  if (!resetToBasic && _swatchTextureState[productId] && _swatchTextureState[productId][colorKey] !== undefined) {
    activeIdx = _swatchTextureState[productId][colorKey];
  } else if (!resetToBasic && fallbackTextureIdx !== undefined) {
    activeIdx = fallbackTextureIdx;
  }
  // Clamp: fallbackTextureIdx may exceed new color's sibling count
  if (activeIdx >= siblings.length) activeIdx = 0;

  var html = '';
  siblings.forEach(function(sib, idx) {
    var label = sib.option_2_name ? sib.option_2_name.replace(/\s*Texture$/i, '') : sib.option_2_name;
    var isActive = idx === activeIdx ? ' is-active' : '';
    // Active pill never struck (mirrors color row); OOS only for non-active pills
    var isOos = (sib.available === false && idx !== activeIdx) ? ' swatch--oos' : '';
    html += '<button class="sibling-swatches-card__texture-btn' + isActive + isOos + '" data-texture-idx="' + idx + '" type="button">' + label + '</button>';
  });
  container.innerHTML = html;

  var buttons = container.querySelectorAll('.sibling-swatches-card__texture-btn');
  buttons.forEach(function(btn) {
    if (btn.classList.contains('swatch--oos')) return;
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var idx = parseInt(btn.getAttribute('data-texture-idx'), 10);
      var target = siblings[idx];

      if (!_swatchTextureState[productId]) _swatchTextureState[productId] = {};
      _swatchTextureState[productId][colorKey] = idx;

      doSiblingSwap(card, target);

      buttons.forEach(function(b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });
}

document.addEventListener('click', function (e) {
  var swatch = e.target.closest('.sibling-swatches-card__swatch');
  if (!swatch) return;

  e.preventDefault();
  e.stopPropagation();

  if (swatch.classList.contains('is-active')) return;
  if (swatch.classList.contains('swatch--oos')) return;

  try {
    var swatchCard = swatch.closest('.sibling-swatches-card');
    if (!swatchCard) return;

    var card = swatchCard.closest('.product__grid-item');
    if (!card) return;

    var cardId = swatchCard.dataset.cardId;
    var scriptEl = swatchCard.querySelector('script[data-sibling-data="' + cardId + '"]');
    if (!scriptEl) return;

    var data = JSON.parse(scriptEl.textContent);
    var siblingsByOp1 = data.siblings_by_option_1_name;

    var op1Key = (swatch.dataset.tooltip || '').toLowerCase().trim().replace(/  +/g, ' ');
    var entry = siblingsByOp1[op1Key];
    if (!entry) return;

    var op2Siblings = entry.option_2_siblings;
    if (!op2Siblings || !op2Siblings.length) {
      // Single-axis product (no texture variants): swap the card image IN PLACE
      // using the color's representative swap data emitted at the entry level.
      // Same swap path as tier cards — only the data source differs. No navigation.
      doSiblingSwap(card, entry);
      swatchCard.querySelectorAll('.sibling-swatches-card__swatch').forEach(function (s) {
        s.classList.remove('is-active');
      });
      swatch.classList.add('is-active');
      var emptyPicker = card.querySelector('[data-texture-picker]');
      if (emptyPicker) emptyPicker.innerHTML = '';
      return;
    }

    var currentTextureBtn = card.querySelector('.sibling-swatches-card__texture-btn.is-active');
    var carryTextureIdx = currentTextureBtn ? parseInt(currentTextureBtn.getAttribute('data-texture-idx'), 10) : 0;

    // Resolve to first available texture for the new color.
    // Carried idx may be OOS or out of range for the new color — never land on a struck pill.
    var resolvedIdx = 0;
    var carrySib = op2Siblings[carryTextureIdx];
    if (carrySib && carrySib.available !== false) {
      resolvedIdx = carryTextureIdx;
    } else {
      for (var i = 0; i < op2Siblings.length; i++) {
        if (op2Siblings[i].available !== false) { resolvedIdx = i; break; }
      }
    }

    var target = op2Siblings[resolvedIdx] || op2Siblings[0];

    doSiblingSwap(card, target);

    swatchCard.querySelectorAll('.sibling-swatches-card__swatch').forEach(function (s) {
      s.classList.remove('is-active');
    });
    swatch.classList.add('is-active');

    buildTexturePicker(card, op1Key, data, false, resolvedIdx);

  } catch (err) {
    console.error('[sibling-swatches] Swap error:', err);
  }
});

// ── Fix primary image disappearing on hover ───────────────────────────────────
// The theme's hover JS sets opacity/visibility as inline styles on the primary
// img, which can override CSS rules. This observer immediately resets them.
(function fixPrimaryImageHover() {
  function observeWrap(wrap) {
    var img = wrap.querySelector('img:not(.secondary)');
    if (!img) return;
    var obs = new MutationObserver(function () {
      if (img.style.opacity === '0' || img.style.visibility === 'hidden') {
        img.style.opacity = '1';
        img.style.visibility = 'visible';
      }
    });
    obs.observe(img, { attributes: true, attributeFilter: ['style'] });
  }

  // Accept an optional root element so load-more can scope re-init to new cards only.
  // When root is provided, .closest() handles the case where root itself carries
  // .has-secondary-image-swap (querySelectorAll only finds descendants, not the root).
  function run(root) {
    if (!root) {
      document.querySelectorAll('.has-secondary-image-swap .image-element__wrap').forEach(observeWrap);
    } else {
      root.querySelectorAll('.image-element__wrap').forEach(function(wrap) {
        if (wrap.closest('.has-secondary-image-swap')) observeWrap(wrap);
      });
    }
  }

  window.GS = window.GS || {};
  window.GS.reinitPrimaryImageHoverFix = run;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { run(); });
  } else {
    run();
  }
})();

// ── Cap zoom image width to 2x container ─────────────────────────────────────
// jQuery Zoom sets inline width/height on .zoomImg based on the natural image
// size. When the image is very large this creates excessive panning distance.
// We watch for style mutations and clamp to 2x the .zoom-container width.
(function capZoomImageSize() {
  function clampZoomImg(zoomImg) {
    var container = document.querySelector('.zoom-container');
    if (!container) return;

    var containerWidth = container.getBoundingClientRect().width;
    if (!containerWidth) return;

    var inlineWidth = parseFloat(zoomImg.style.width);
    var inlineHeight = parseFloat(zoomImg.style.height);
    if (!inlineWidth || !inlineHeight) return;

    var maxWidth = containerWidth * 2;
    if (inlineWidth <= maxWidth) return;

    var newWidth = maxWidth;
    var newHeight = (inlineHeight / inlineWidth) * newWidth;
    zoomImg.style.width = newWidth + 'px';
    zoomImg.style.height = newHeight + 'px';
  }

  function run() {
    var gallery = document.querySelector('.product-gallery');
    if (!gallery) return;

    var obs = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.target.classList.contains('zoomImg')) {
          clampZoomImg(mutation.target);
        } else if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1 && node.classList.contains('zoomImg')) {
              clampZoomImg(node);
            }
          });
        }
      });
    });

    obs.observe(gallery, { subtree: true, childList: true, attributes: true, attributeFilter: ['style'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

// ── Init texture picker on page load ─────────────────────────────────────────
// Exposed as window.GS.initTexturePickers(root) so load-more can re-init
// newly-appended cards. Pass a card element to scope; omit for full-page init.
(function initTexturePickers() {
  function run(root) {
    (root || document).querySelectorAll('.sibling-swatches-card').forEach(function(swatchCard) {
      var card = swatchCard.closest('.product__grid-item');
      if (!card) return;
      var cardId = swatchCard.dataset.cardId;
      var scriptEl = swatchCard.querySelector('script[data-sibling-data="' + cardId + '"]');
      if (!scriptEl) return;
      var siblingData;
      try { siblingData = JSON.parse(scriptEl.textContent); } catch(e) { return; }
      var activeSwatch = swatchCard.querySelector('.sibling-swatches-card__swatch.is-active');
      if (activeSwatch && siblingData) {
        var initColorKey = (activeSwatch.getAttribute('data-tooltip') || '').toLowerCase().trim().replace(/  +/g, ' ');
        // Highlight the texture pill matching THIS card's product (its option_2),
        // not index 0. Liquid emits data-current-option-2-key using the same
        // transform as the JSON option_2_key, so this matches byte-for-byte.
        // Omitted attr (no option_2) or no match → undefined → index-0 fallback.
        var currentOp2Key = swatchCard.getAttribute('data-current-option-2-key');
        var fallbackTextureIdx;
        if (currentOp2Key) {
          var colorData = siblingData.siblings_by_option_1_name[initColorKey];
          if (colorData && colorData.option_2_siblings) {
            for (var i = 0; i < colorData.option_2_siblings.length; i++) {
              if (colorData.option_2_siblings[i].option_2_key === currentOp2Key) {
                fallbackTextureIdx = i;
                break;
              }
            }
          }
        }
        buildTexturePicker(card, initColorKey, siblingData, false, fallbackTextureIdx);
      }
    });
  }
  window.GS = window.GS || {};
  window.GS.initTexturePickers = run;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { run(); });
  } else {
    run();
  }
})();

// ── Collection "Load more" ────────────────────────────────────────────────────
// Progressive enhancement: native .paginate nav stays in the DOM for crawlers
// and no-JS users (visually hidden via gs-load-more--hidden). JS injects a
// "Load more" button and fetches pages via the Shopify section rendering API
// (?section_id=collection__main&page=N) which returns only the section HTML,
// already deduped server-side, with no bot-detection risk.
//
// Full-rows guarantee: cards from each batch are held in a pending buffer and
// only complete rows (floor(total / cols) * cols) are appended to the grid.
// Overflow waits for the next batch. The genuine last page flushes everything.
//
// Delegated handlers (ATC click, swatch click) need no re-init — they fire on
// document. initTexturePickers and reinitPrimaryImageHoverFix are re-run scoped
// to each newly-appended card.
//
// Inert on single-page collections (no .paginate rendered → early return).
(function collectionLoadMore() {
  var MOBILE_BREAKPOINT = 768;

  function getCols() {
    return window.innerWidth >= MOBILE_BREAKPOINT ? 3 : 2;
  }

  // Build the section API URL for a given page, preserving existing params
  // (sort_by, filters, preview_theme_id, etc.) and overriding only page + section_id.
  function buildFetchUrl(page) {
    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.set('section_id', 'collection__main');
    params.set('page', String(page));
    return window.location.pathname + '?' + params.toString();
  }

  function init() {
    var paginateEl = document.querySelector('.paginate[data-paginate-pages]');
    if (!paginateEl) return; // single-page collection or non-paginated template — no-op

    var totalPages = parseInt(paginateEl.getAttribute('data-paginate-pages'), 10);
    var currentPage = parseInt(paginateEl.getAttribute('data-current-page'), 10);
    if (isNaN(totalPages) || totalPages <= 1) return;

    var grid = document.querySelector('.collection-matrix');
    if (!grid) return;

    // Only activate when a next page exists. If the user lands directly on the
    // last page (e.g. /collections/all?page=3), native nav stays visible and no
    // Load more button is injected — orphan cards on the last page must remain
    // visible (no future batch to show them). .pagination-next is emitted by the
    // pagination snippet only when paginate.next exists, making it the canonical
    // "more pages ahead" signal.
    var hasMorePages = !!document.querySelector('.pagination-next');
    if (!hasMorePages) return;

    // Prevent the browser from auto-restoring a saved scroll offset when
    // replaceState updates the URL to ?page=N (history.scrollRestoration='auto'
    // is the default and can cause a jump to position 0 on re-entry).
    if (window.history && window.history.scrollRestoration) {
      window.history.scrollRestoration = 'manual';
    }

    // ── Seed pending with initial-page orphan cards ──────────────────────────
    // The server-rendered grid may end with a partial row (e.g. 25 cards at
    // 3-wide = 8 full rows + 1 orphan). Detach the trailing orphan(s) into
    // pending synchronously — before first paint at DOMContentLoaded — so the
    // initial grid shows only complete rows with no visible card disappear.
    // Orphans go FIRST in pending so product order is preserved: initial orphans
    // always appear before next-page cards when their row completes.
    var cols = getCols();
    var serverCards = Array.from(grid.querySelectorAll('.product__grid-item'));
    var orphanCount = serverCards.length % cols;
    var pending = [];   // overflow buffer: initial orphans first, then next-page remainders
    if (orphanCount > 0) {
      var orphans = serverCards.slice(serverCards.length - orphanCount);
      orphans.forEach(function(card) { card.parentNode.removeChild(card); });
      pending = orphans;
    }

    // Visually hide native pagination; keep in DOM for crawlers + no-JS fallback
    paginateEl.classList.add('gs-load-more--hidden');

    // Build Load more button and insert it before the pagination container
    var btn = document.createElement('button');
    btn.className = 'gs-load-more__btn button button--primary';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'View more products');
    btn.innerHTML =
      '<span class="gs-load-more__label">View More</span>' +
      '<svg class="gs-load-more__chevron" width="16" height="16" viewBox="0 0 16 16"' +
      ' fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M8 2v11M5 9l3 4 3-4" stroke="currentColor" stroke-width="2"' +
      ' stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';

    var btnWrapper = document.createElement('div');
    btnWrapper.className = 'gs-load-more__wrapper container';
    btnWrapper.appendChild(btn);

    var paginationContainer = document.querySelector('.container--pagination');
    if (paginationContainer) {
      paginationContainer.parentNode.insertBefore(btnWrapper, paginationContainer);
    } else {
      grid.parentNode.appendChild(btnWrapper);
    }

    // ── State ───────────────────────────────────────────────────────────────
    var nextPage = currentPage + 1;
    var loading = false;
    // pending is declared and initialized above (orphans or [])

    function flushPending(isLastPage) {
      var cols = getCols();
      var renderCount = isLastPage
        ? pending.length
        : Math.floor(pending.length / cols) * cols;

      if (renderCount === 0) return;

      var toRender = pending.slice(0, renderCount);
      pending = pending.slice(renderCount);

      toRender.forEach(function(card) { grid.appendChild(card); });

      // Re-init per-card JS (texture pickers + hover observer) on new cards.
      // Delegated handlers (ATC, swatch click) already cover new elements — skip.
      if (window.GS) {
        toRender.forEach(function(card) {
          window.GS.initTexturePickers(card);
          window.GS.reinitPrimaryImageHoverFix(card);
        });
      }
    }

    // ── Click handler ────────────────────────────────────────────────────────
    btn.addEventListener('click', function() {
      if (loading) return;
      loading = true;
      btn.disabled = true;
      btn.querySelector('.gs-load-more__label').textContent = 'Loading…';

      fetch(buildFetchUrl(nextPage))
        .then(function(res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          var newCards = Array.from(doc.querySelectorAll('.product__grid-item'));
          var isLastPage = !doc.querySelector('.pagination-next');

          // Capture scroll position just before DOM mutation. Restoring after
          // btn.disabled=false prevents mobile browsers from scrolling to the
          // re-enabled button (the primary cause of the post-load scroll jump).
          var scrollY = window.scrollY || window.pageYOffset;

          pending = pending.concat(newCards);
          flushPending(isLastPage);

          // Update URL to reflect furthest page loaded. replaceState keeps the
          // history stack clean (back button goes to the page before collection,
          // not to intermediate load-more steps).
          var newUrl = window.location.pathname + '?page=' + nextPage;
          if (window.history && window.history.replaceState) {
            window.history.replaceState({ gsPage: nextPage }, '', newUrl);
          }

          nextPage++;
          loading = false;

          if (isLastPage) {
            btnWrapper.style.display = 'none';
          } else {
            btn.disabled = false;
            btn.querySelector('.gs-load-more__label').textContent = 'View More';
          }

          // Restore scroll after all DOM/state changes (including btn.disabled=false).
          // rAF defers one frame, running after the browser's implicit scroll-to-element
          // response to re-enabling the button, so our restore wins.
          window.requestAnimationFrame(function() {
            window.scrollTo(0, scrollY);
          });
        })
        .catch(function(err) {
          console.error('[gs-load-more] fetch error:', err);
          loading = false;
          btn.disabled = false;
          btn.querySelector('.gs-load-more__label').textContent = 'View More';
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ── UpCart desktop scroll fix ─────────────────────────────────────────────────
// UpCart locks body overflow but leaves <html> scrollable, and the cart's scroll
// container lives in a Shadow DOM so wheel events over the backdrop miss it.
// UpCart overwrites window.upcartOnCartOpened/Closed after page load, so we
// watch body.classList via MutationObserver instead — reliable regardless of
// UpCart's initialization order.
// On desktop: while .upcartPopupShow is on <body>, all wheel events are
// redirected into .upcart-cart-body. Events already targeting the scroller
// are passed through untouched to avoid double-scrolling.
(function () {
  if (window.__upcartScrollFixInstalled) return;
  window.__upcartScrollFixInstalled = true;

  var wheelOpts = { passive: false, capture: true };

  function wheelHandler(e) {
    var host = document.getElementById('upCart');
    if (!host || !host.shadowRoot) return;
    var scroller = host.shadowRoot.querySelector('.upcart-cart-body');
    if (!scroller) return;
    // If the event path already includes the scroller, let native scroll handle it.
    if (e.composedPath && e.composedPath().indexOf(scroller) !== -1) return;
    scroller.scrollTop += e.deltaY;
    e.preventDefault();
  }

  function onDrawerOpen() {
    if (window.innerWidth >= 768) {
      window.addEventListener('wheel', wheelHandler, wheelOpts);
    }
  }

  function onDrawerClose() {
    window.removeEventListener('wheel', wheelHandler, wheelOpts);
  }

  function observe() {
    var lastOpen = document.body.classList.contains('upcartPopupShow');
    // Handle case where drawer is already open when this runs
    if (lastOpen) onDrawerOpen();

    new MutationObserver(function () {
      var isOpen = document.body.classList.contains('upcartPopupShow');
      if (isOpen === lastOpen) return;
      lastOpen = isOpen;
      if (isOpen) {
        onDrawerOpen();
      } else {
        onDrawerClose();
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();

/* =========================================================
   Disable theme jQuery hover-zoom on PDP images.
   Click-to-zoom (Fancybox lightbox) is a separate path and
   stays fully working. We strip data-zoom-src before the
   theme's enableZoom() reads it (it no-ops without a zoom src),
   and remove any overlay the theme may have already created.
   Revert: delete this block (and re-add data-zoom-src usage).
   ========================================================= */
(function () {
  function killHoverZoom(img) {
    if (!img) return;
    // Stop theme's enableZoom from initializing zoom on this image.
    img.removeAttribute('data-zoom-src');
    // Backstop: if it already wrapped/overlaid, undo it.
    var p = img.parentElement;
    if (p && p.classList.contains('zoom-container')) {
      var stray = p.querySelector('img.zoomImg');
      if (stray) stray.remove();
      p.parentNode.insertBefore(img, p);
      p.parentNode.removeChild(p);
    }
    var c = img.closest('.image__container');
    if (c) c.querySelectorAll('img.zoomImg').forEach(function (z) { z.remove(); });
  }

  // Strip on lazyloaded (fires per image as lazysizes loads it).
  document.addEventListener('lazyloaded', function (e) {
    var img = e.target;
    if (img && img.matches && img.matches('.image__container img')) killHoverZoom(img);
  });

  // Catch any images already processed before this ran.
  document.querySelectorAll('.image__container img').forEach(killHoverZoom);
})();
